export const PHARMACIST_TAB_LABELS = {
  dashboard: 'Dashboard',
  createShift: 'Create Shift',
  manageShifts: 'Manage Shifts',
  bookingsApplicants: 'Bookings / Applicants',
  profile: 'Profile'
} as const;

export const LOCUM_TAB_LABELS = {
  dashboard: 'Dashboard',
  findShifts: 'Find Shifts',
  myBookings: 'My Bookings',
  profile: 'Profile'
} as const;
